import ComponentAutoloader from './ComponentAutoloader'

ComponentAutoloader.register()
